import React from "react";
import { Helmet } from "react-helmet";
import classes from "./Billing.module.scss";

const Billing = () => {
  return (
    <>
      <Helmet>
        <title>Billing | DDD Invoices</title>
      </Helmet>
      <div className="h-100 w-100 p-5">
        <h2 className={`${classes.title} mb-2`}>Billing</h2>
        <div>
          There are currently no billed invoices. Once an invoice gets billed by
          the service, it will appear here.
        </div>
      </div>
    </>
  );
};

export default Billing;
